import { Link } from 'react-router-dom';

const highlights = [
  {
    id: 1,
    title: '某顶流男星深夜密会神秘女子，酒店共度8小时细节全曝光',
    summary: '据知情人士透露，该男星近日在某五星级酒店与一名神秘女子共度长达8小时。监控画面显示两人举止亲密，这与此前其公开的单身人设严重不符。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20cinematic%20scene%20of%20a%20luxury%20hotel%20corridor%20at%20night%2C%20mysterious%20atmosphere%2C%20silhouette%20of%20two%20people%2C%20warm%20dim%20lighting%2C%20noir%20style%2C%20dark%20background%2C%20editorial%20photography%2C%20high%20contrast%2C%20elegant%20composition%2C%20soft%20shadows%2C%20moody%20ambiance%2C%20cinematic%20lighting&width=600&height=400&seq=article-01&orientation=landscape',
    tag: '独家',
    views: '12.9万',
    comments: 3421,
    publishDate: '2026-06-30',
  },
  {
    id: 2,
    title: '知名女星税务风波再升级，补缴金额或超2亿，多个代言紧急解约',
    summary: '继此前被曝税务问题后，该女星近日再被查出新的税务漏洞。据税务机关内部人士透露，累计补缴金额可能突破2亿元，多家品牌方已启动紧急解约程序。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dark%20minimalist%20scene%20with%20scattered%20financial%20documents%20on%20a%20glossy%20black%20desk%2C%20dramatic%20lighting%20from%20above%2C%20red%20seal%20stamps%2C%20luxury%20atmosphere%2C%20editorial%20style%2C%20dark%20background%2C%20cinematic%20mood%2C%20high%20contrast%2C%20professional%20composition&width=600&height=400&seq=article-02&orientation=landscape',
    tag: '独家',
    views: '25.6万',
    comments: 8921,
    publishDate: '2026-06-29',
  },
  {
    id: 3,
    title: '某综艺节目录制现场爆发激烈冲突，两位嘉宾当场翻脸罢录',
    summary: '据悉，在某热门综艺最新一期录制过程中，两位人气嘉宾因游戏环节产生严重分歧，爆发激烈争吵后双双罢录，节目组紧急叫停拍摄。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dark%20TV%20studio%20set%20with%20dramatic%20red%20and%20blue%20stage%20lighting%2C%20empty%20chairs%2C%20tense%20atmosphere%2C%20scattered%20props%20on%20floor%2C%20cinematic%20style%2C%20dark%20background%2C%20editorial%20photography%2C%20high%20contrast%2C%20moody%20lighting&width=600&height=400&seq=article-03&orientation=landscape',
    tag: '精华',
    views: '18.9万',
    comments: 5632,
    publishDate: '2026-06-28',
  },
  {
    id: 4,
    title: '揭秘：某热门电影票房造假内幕，午夜幽灵场上座率达100%',
    summary: '本报记者经过数月调查，发现某近期上映的热门影片存在严重的票房造假行为。多地的午夜场次出现"满座"奇观，但实际观影人数寥寥无几。',
    imageUrl: 'https://readdy.ai/api/search-image?query=An%20empty%20movie%20theater%20with%20red%20seats%20in%20darkness%2C%20single%20projector%20beam%20cutting%20through%2C%20eerie%20atmosphere%2C%20cinematic%20noir%20style%2C%20dark%20background%2C%20editorial%20photography%2C%20high%20contrast%2C%20moody%20ambiance&width=600&height=400&seq=article-04&orientation=landscape',
    tag: '独家',
    views: '31.2万',
    comments: 12450,
    publishDate: '2026-06-27',
  },
];

export default function HighlightsGrid() {
  return (
    <section id="highlights" className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-12 gap-3">
          <div>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-50 mb-2">
              往期精华
            </h2>
            <p className="text-foreground-400 text-sm md:text-base">
              每日大赛往期内容 &middot; 免费回顾
            </p>
          </div>
          <Link
            to="/category/meiri-dasai"
            className="text-primary-400 text-sm hover:text-primary-300 transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {highlights.map((article) => (
            <article key={article.id} className="group relative rounded-xl overflow-hidden bg-background-200/80 border border-white/10 hover:border-primary-500/30 transition-all duration-300">
              <Link to={`/article/${article.id}`} className="block">
                <div className="relative h-56 md:h-60 overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    title={`${article.title} - 51爆料网`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-200/90 via-transparent to-transparent" />
                  {article.tag && (
                    <span className="absolute top-3 right-3 px-3 py-1 bg-primary-500/90 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                      {article.tag}
                    </span>
                  )}
                </div>

                <div className="p-5">
                  <h3 className="text-foreground-100 font-heading font-semibold text-sm leading-snug line-clamp-2 group-hover:text-primary-400 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-foreground-500 text-sm mt-3 line-clamp-2 leading-relaxed">
                    {article.summary}
                  </p>
                  <div className="flex items-center gap-4 mt-4 text-foreground-600 text-xs">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line" />
                      {article.views}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line" />
                      {article.comments}
                    </span>
                    <span className="ml-auto text-foreground-700">{article.publishDate}</span>
                  </div>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}